export default __webpack_public_path__ + "static/media/exit-exam-icon.9d5010d4.svg";